import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { Provider as StoreProvider } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { rootRoute } from "@routes";
import { setupStore } from "@store";
import { ErrorBoundary, Loading } from "@components";

const container = document.getElementById("Application");

if (container === undefined) {
    throw new Error("Error: Cannot get Application element from index.html");
}

const store = setupStore();
const root = createRoot(container as HTMLElement);
const router = createBrowserRouter([rootRoute]);

root.render(
    <React.StrictMode>
        <ErrorBoundary>
            <StoreProvider store={store}>
                <Suspense fallback={<Loading />}>
                    <RouterProvider router={router} />
                </Suspense>
            </StoreProvider>
        </ErrorBoundary>
    </React.StrictMode>,
);
